import React, { Dispatch, SetStateAction } from 'react';
import ToggleButton from '@mui/material/ToggleButton';

interface LabeledToggleButtonProps {
  onLabel: string;
  offLabel: string;
  param: string;
  formValues: Record<string, any>;
  setFormValues: Dispatch<SetStateAction<Record<string, any>>>;
}

const LabeledToggleButton: React.FC<LabeledToggleButtonProps> = (props) => {
  const { onLabel, offLabel, param, formValues, setFormValues } = props;

  const isOn = Boolean(formValues?.[param]);
  const labelToUse = isOn ? onLabel : offLabel;

  const handleToggle = () => {
    setFormValues((prev) => ({
      ...prev,
      [param]: !Boolean(prev?.[param]),
    }));
  };

  return (
    <ToggleButton
      value="check"
      selected={isOn}
      onChange={handleToggle}
      sx={{
        width: 160,
        height: 50,
        justifyContent: 'center',
        lineHeight: 1.2,
        '&.Mui-selected': {
          backgroundColor: 'DodgerBlue !important',
          color: '#ffffff !important',
          '&:hover': {
            backgroundColor: 'DeepSkyBlue !important',
          },
        },
      }}
    >
      {labelToUse}
    </ToggleButton>
  );
};

export default LabeledToggleButton;
